/**
 * Sharing something of one's own with others at the company, as Drive's top folders and Boards' boards are: each grant
 * reaches a person (their account), a branch, a department, or everyone at the company, and what it lets them do is the
 * app's own role. Moving branch or department moves what reaches someone that way (apps/api/src/lib/sharing.ts).
 */

export const shareKinds = ['user', 'branch', 'department', 'company'] as const
export type ShareKind = (typeof shareKinds)[number]

/** The company's grant names no one: its target is this */
export const SHARE_COMPANY = '*'

/** Someone or something a thing may be shared with, as the picker offers it */
export interface ShareTarget {
  kind: ShareKind
  targetId: string
  /** The person's, branch's or department's (the company's: empty, its kind names it) */
  name: string
  /** A person's branch */
  sub?: string
}

/** A grant as its owner sees it: whom it reaches, by name, and as what */
export interface ShareGrant<Role extends string = string> extends ShareTarget {
  role: Role
}

/** Whom a thing is shared with, by name (the company's is its kind's), as lists show it */
export interface ShareName {
  kind: ShareKind
  name: string
}
